import React from 'react';
import { _ } from '../../../functions/translator';
import Tooltip from '@material-ui/core/Tooltip';
import { shortString } from '../../../functions/utils';

class StretchInfo extends React.Component{

    render(){

        let stretchValue = this.props.cardsGroup.attributes.stretch ? this.props.cardsGroup.attributes.stretch : _('Ninguna')

        let truncatedStretch = shortString(stretchValue);
        let stretch = _("Tramo")

        if (this.props.customcard) {
            if (!this.props.customcard.attributes.stretch) return <div></div>
            stretch = this.props.customcard.attributes.stretch
        }

        return (
            <div className='info-container'>
                <p className='card-text'>{ stretch }</p>
                <Tooltip arrow title={ stretchValue } placement="right">
                    <span className='text card-description'>{ truncatedStretch }</span>
                </Tooltip> 
            </div>
        );
    }
}

export default StretchInfo;